import React, { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/DeleteOutlineOutlined';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQrcode } from '@fortawesome/free-solid-svg-icons';
import { QRDialog } from 'components/QrDialog/QRDialog';
import { AlertDialog } from 'components/UI/Dialog/AlertDialog';
import { Row } from 'components/UI/Row';
import { deleteProduct, getLoaders } from './products';

const ProductActions: FC<{ product?: any }> = ({ product }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isDeletingItems } = useSelector(getLoaders);
  const [showQrModal, setShowQrModal] = useState<boolean>(false);
  const [showConfirmDelete, setShowConfirmDelete] = useState<boolean>(false);

  return (
    <Row justifyContent="flex-end">
      <div>
        <IconButton
          aria-label="product-qr-code"
          color="primary"
          onClick={e => {
            e.stopPropagation();
            setShowQrModal(true);
          }}
        >
          <FontAwesomeIcon icon={faQrcode} />
        </IconButton>
      </div>
      <div style={{ position: 'relative' }}>
        <IconButton
          aria-label="delete"
          color="secondary"
          disabled={isDeletingItems && isDeletingItems[product.id]}
          onClick={e => {
            e.stopPropagation();
            setShowConfirmDelete(true);
          }}
        >
          <DeleteIcon />
        </IconButton>
        {isDeletingItems && isDeletingItems[product.id] && (
          <CircularProgress
            color="secondary"
            size={34}
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              marginTop: -17,
              marginLeft: -17
            }}
          />
        )}
      </div>

      <QRDialog
        closeFn={() => setShowQrModal(false)}
        qrValue={product?.qr}
        qrDescription={product?.id}
        productName={product?.name || ''}
        open={showQrModal}
      />
      <AlertDialog
        handleAccept={() => {
          dispatch(deleteProduct(product.id));
          setShowConfirmDelete(false);
        }}
        handleCancel={() => {
          setShowConfirmDelete(false);
        }}
        open={showConfirmDelete}
        title={t('products.delete confirm title')}
        text={[
          t('products.delete confirm text.line1'),
          t('products.delete confirm text.line2'),
          t('products.delete confirm text.line3')
        ]}
      />
    </Row>
  );
};

export { ProductActions };
